import { useContext } from 'react'
import { CompanyContext } from './company-context-provider'

export const useCompany = () => {
  // get the context
  const context = useContext(CompanyContext)

  // if `undefined`, throw an error
  if (context === undefined) {
    throw new Error('useCompany was used outside of its Provider')
  }

  return context
}
